const state = {
  identifier: null,
  key: null,
  mediaType: '',
  type: '',
  color: '',
  imageUrl: '',
};

export const getters = {
  getActiveItem(state) {
    return state;
  },
};

const actions = {
  setActiveItem({ commit }, item) {
    commit('setActiveItem', item);
  },
  resetActiveItem({ commit }) {
    const item = {
      identifier: null,
      key: null,
      mediaType: '',
      type: '',
      color: '',
      imageUrl: '',
    };

    commit('setActiveItem', item);
  },
};

const mutations = {
  setActiveItem(state, item) {
    const { identifier, key, mediaType, type, color, imageUrl } = item;

    state.identifier = identifier;
    state.key = key;
    state.mediaType = mediaType;
    state.type = type;
    state.color = color;
    state.imageUrl = imageUrl;
  },
};

const namespaced = true;

export const activeItem = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
